import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { 
  FaTelegramPlane,
 } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm skilled in <b className="purple">Unity 3D/VR</b> development, and fluent in
              <b className="purple"> C#, C++, and TypeScript</b>.
              <br/>
              <br/>
              I also have hands-on experience with <b className="purple">embedded systems and low-level hardware programming</b>.
              <br/>
              <br/>
              My focus is on combining software and hardware to build interactive<b className="purple"> simulations</b> for education and
              <b className="purple"> training</b>.
              <br />
              <br/>
              I’m always passionate about turning ideas into <b className="purple">real-world products</b>.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://t.me/VincentTong96"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaTelegramPlane />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
